export * from './lib/full-layout.module';
export * from './lib/lib.routes';

export * from './lib/lib.routes';

export * from './lib/view-order/view-order.component';
export * from './lib/view-truck/view-truck.component';
